<template>
  <div class="prescriptionData">
    <!-- “prescriptionData”限制css于本页面 -->
    <sirui-search
      ref="siruiSearch"
      :query="searchForm"
      :columns="searchColumns"
      @resetBtnClick="resetBtnClick"
      @searchBtnClick="searchBtnClick"
      @changeCompany="changeCompany"
    >
    </sirui-search>
    <!-- raw -->
    <div class="main-content">
      <sirui-table
        ref="siruiTable"
        :buttonList="menuButtonList"
        :loading="load"
        :data="tableData"
        :paging="true"
        :reserve="false"
        :setting="false"
        :customVisible="true"
        :columns="columnList"
        @chooseClick="chooseClick"
        @dblclickEvent="dblclickEvent"
        @handleSizeChange="handleSizeChange"
        @handleCurrentChange="handleCurrentChange"
        @handleSelectionChange="handleSelectionChange"
      >
        <vxe-table-column type="checkbox" fixed="left" width="60"></vxe-table-column>
        <vxe-table-column
          v-for="(item, index) in columnList"
          :key="index"
          :fixed="item.fixed"
          :visible="item.visible"
          :width="item.width"
          :sortable="item.sortable"
          :field="item.field"
          :type="item.type"
          :title="item.title ? $t(item.title) : null"
        >
          <template v-if="item.field == 'confimProductNameSpec'" v-slot:content="{ row }">
            <div class="childDataTable">
              <vxe-table
                resizable
                :auto-resize="true"
                border
                :data="showChild(row)"
                :valid-config="{ autoPos: true, message: 'inline' }"
              >
                <vxe-table-column
                  v-for="childs in column"
                  :key="childs.field"
                  :width="childs.width || 120"
                  :field="childs.field"
                  :title="childs.title"
                >
                </vxe-table-column>
              </vxe-table>
            </div>
          </template>

          <template slot-scope="scope">
            <span v-if="item.dictType">
              {{ scope.row[item.field] | getDictNameByCode(item.dictType) }}
            </span>
            <span v-else>{{ scope.row[item.field] }}</span>
          </template>
        </vxe-table-column>
      </sirui-table>
    </div>
    <!-- 导入 -->
    <sirui-upload
      :data="importData"
      :action="importUrl"
      fileList=".xls,.xlsx"
      v-on:getData="getData"
      ref="siruiUpload"
    >
    </sirui-upload>
  </div>
</template>
<script>
  import { mapState } from 'vuex';
  import API from '@/api/productCenter/rawData';
  import DataBaseAPI from '@/api/dataBase';
  import tableMixins from '@/common/mixins/table.js';
  import SiruiSearch from '@/components/SiruiSearch';
  import SiruiTable from '@/components/SiruiTable';
  import siruiUpload from '@/components/SiruiUpload';
  // import DictSpan from '@/components/DictSpan';
  import XEUtils from 'xe-utils';
  export default {
    name: 'rawDataList',
    mixins: [tableMixins],
    components: {
      SiruiSearch,
      SiruiTable,
      siruiUpload,
    },
    computed: {
      ...mapState({
        userInfo: (state) => state.userInfo.userInfo,
        // 状态 => 用于表格回显
        requestStatusData(state) {
          let dictList = state.dict.dictList;
          if (dictList.length > 0) {
            return dictList.find((it) => it.dictType == 'request_status').dictList;
          } else {
            return [];
          }
        },
      }),
      token() {
        return {
          access_token: this.userInfo.access_token,
          companyCode: this.userInfo.companyCode,
          companyName: this.userInfo.companyName,
          departmentCode: this.userInfo.departmentCode,
          departmentName: this.userInfo.departmentName,
          tenantCode: this.userInfo.tenantCode,
        };
      },

      // 搜索栏表格展示字段
      searchColumns() {
        return [
          //   原料编号
          {
            name: this.$t('rawData.search.productCode'),
            prop: 'productCode',
            type: 'input',
            //querySearch: this.productCodeSearch
          },
          //   原料名称
          {
            name: this.$t('rawData.search.productName'),
            prop: 'productName',
            type: 'input',
            //querySearch: this.productNameSearch
          },
          //   主料/辅料
          {
            name: this.$t('rawData.search.productType'),
            prop: 'productType',
            type: 'dict',
            dictType: 'productType',
          },
          //   原料大类
          {
            name: this.$t('rawData.search.productCategory'),
            prop: 'productCategory',
            type: 'dict',
            dictType: 'produce_product_category',
          },
          //   校准名称
          {
            name: this.$t('rawData.search.productConfirmName'),
            prop: 'productConfirmName',
            type: 'input',
            //querySearch: this.productConfirmNameSearch
          },
          //   数据状态
          {
            name: this.$t('rawData.search.productStatus'),
            prop: 'productStatus',
            type: 'dict',
            dictType: 'produce_product_status',
          },
          //   项目名称
          {
            name: this.$t('rawData.search.projectName'),
            prop: 'projectCode',
            type: 'dict',
            dictType: 'produce_product_proname',
          },
          //   成本类型
          {
            name: this.$t('rawData.search.costType'),
            prop: 'costType',
            type: 'dict',
            dictType: 'produce_product_trade_type',
          },
        ];
      },
    },
    data() {
      return {
        multipleSelection: [],
        importData: {}, // 导入参数
        importUrl: '', // 导入地址
        searchForm: {
          productClass: '0',
          productCode: null,
          productName: null,
          productType: null,
          productCategory: null,
          productConfirmName: null,
          productStatus: null,
          projectCode: null,
          projectName: null,
          costType: null,
        },
        columnListDefault: [
          //{ type: "checkbox", visible: true, width: "50", fixed: "left" },
          { field: 'productCode', title: 'rawData.label.productCode', visible: true, width: 110 },
          { field: 'productName', title: 'rawData.label.productName', visible: true, width: 140 },
          { field: 'productSpec', title: 'rawData.label.productSpec', visible: true, width: 130 },
          {
            field: 'productStatus',
            title: 'rawData.label.productStatus',
            visible: true,
            width: 130,
            dictType: 'produce_product_status',
          },
          {
            field: 'productType',
            title: 'rawData.label.productType',
            visible: true,
            width: 80,
            dictType: 'productType',
          },
          {
            field: 'productCategory',
            title: 'rawData.label.productCategory',
            visible: true,
            width: 100,
            dictType: 'produce_product_category',
          },
          {
            field: 'costType',
            title: 'rawData.label.costType',
            visible: true,
            width: 100,
            dictType: 'produce_product_trade_type',
          },
          {
            field: 'projectName',
            title: 'rawData.label.projectName',
            visible: true,
            width: 80,
            dictType: 'produce_product_proname',
          },
          {
            type: 'expand',
            field: 'confimProductNameSpec',
            title: 'rawData.label.productConfirmName',
            visible: true,
          },
        ],
        column: [
          /* {
          type: "seq",
          width: 80,
          title: this.$t("rawData.table.projectCode"),
        }, */
          {
            field: 'productName',
            title: this.$t('rawData.table.productConfirmName'),
            width: 400,
            editRender: { name: 'ElInput', props: { clearable: true } },
          },
          {
            field: 'productSpec',
            width: 400,
            title: this.$t('rawData.table.confimProductNameSpec'),
            editRender: { name: 'ElInput', props: { clearable: true } },
          },
        ],
      };
    },
    mounted() {
      this.getData();
      this.getButtonList();
      this.setImport(),
        /* this.getProductCodeList(),
    this.getProductNameList(),
    this.getProductConfirmNameList(), */
        this.$nextTick(() => {
          //设置导入参数
          this.setImport();
        });
    },
    methods: {
      // 获取列表数据
      getData() {
        this.load = true;
        const { pageNum, pageSize } = this.$refs.siruiTable.page;
        const { adminFlag, tenantCode } = this.userInfo;
        let params = { pageNum, pageSize, adminFlag, tenantCode };
        params = Object.assign(params, this.searchForm);
        this.$axios.post(API.LIST_FUND_COLLECTION_REGISTER_BY_PAGE, params).then((res) => {
          this.load = false;
          if (res.data.code === 0) {
            this.tableData = res.data.data.records;
            this.$refs.siruiTable.setPageTotal(res.data.data.total);
            //重新加载表格
            this.$refs.siruiTable.reloadTable(this.tableData);
          } else {
            this.$alert(res.data.msg);
          }
        });
      },
      // 获取菜单按钮
      getButtonList() {
        this.getButtons().then((e) => {
          this.menuButtonList = e;
          this.getColumnInfo();
        });
      },
      // 获取当前列
      getColumnInfo() {
        this.getColumnList(this.columnListDefault).then((res) => {
          this.columnList = res;
        });
      },
      // 获取产品编号列表
      getProductCodeList() {
        const params = {
          cloumn: 'productCode',
          productClass: '0',
        };
        this.$axios.get(API.PD_SELECT_OPTION, params).then((res) => {
          if (res.data.code === 0) {
            this.productCodeList = res.data.data;
          }
        });
      },
      // 获取产品名称列表
      getProductNameList() {
        const params = {
          cloumn: 'productName',
          productClass: '0',
        };
        this.$axios.get(API.PD_SELECT_OPTION, params).then((res) => {
          if (res.data.code === 0) {
            this.productNameList = res.data.data;
          }
        });
      },
      // 校准名称列表
      // getProductConfirmNameList(){
      //      const params = {
      //         cloumn: 'productName',
      //         productClass:"0"
      //     };
      //     this.$axios.get(API.PD_SELECT_OPTION_ALIAS,params).then(res => {
      //         if(res.data.code === 0) {
      //             this.productConfirmNameList = res.data.data;
      //         }
      //     });
      // },
      // 原料编号模糊查询
      productCodeSearch(queryString, cb) {
        const productCodeList = this.productCodeList;
        const results = queryString
          ? productCodeList.filter(this.createFilter(queryString))
          : productCodeList;
        cb(results);
      },
      // 原料名称模糊查询
      productNameSearch(queryString, cb) {
        const productNameList = this.productNameList;
        const results = queryString
          ? productNameList.filter(this.createFilter(queryString))
          : productNameList;
        cb(results);
      },
      // 校准名称模糊查询
      getProductConfirmNameList(queryString, cb) {
        const productConfirmNameList = this.productConfirmNameList;
        const results = queryString
          ? productConfirmNameList.filter(this.createFilter(queryString))
          : productConfirmNameList;
        cb(results);
      },
      getDictList() {
        // 公司名称
        this.$axios
          .get(DataBaseAPI.LISTDATA_SERECHCOMPANY + `/${this.userInfo.userInfo.tenantCode}`)
          .then((res) => {
            if (res.data.code == 0) {
              this.slipCompanyList = res.data.data;
            }
          });
      },
      chooseClick(value) {
        if (value === 'add') {
          //增加
          this.handleAdd();
        } else if (value === 'importData') {
          //批量导入
          this.handleImport();
        } else if (value === 'exportData') {
          //批量导出
          this.handleExport();
        } else if (value === 'del') {
          //批量删除
          this.handleForbid();
        }
      },
      // 新增
      handleAdd() {
        this.$baseRequest.linkRouteUrl(
          '/production/rawDataAdd',
          'rawDataAdd',
          '新增原料主数据明细'
        );
      },
      // 导出
      handleExport() {
        if (this.tableData.length == 0) {
          return this.$message({
            showClose: true,
            message: this.$t('message.noExport'),
            type: 'error',
          });
        }
        const selectedList = this.$refs.siruiTable.getCheckboxReserveRecords(); // 历史选中数据
        let changeList = this.multipleSelection.concat(selectedList);
        if (changeList.length > 0) {
          let str = 'ids=';
          // let ids = changeList.forEach((item) => {
          //   str += '' + item.id + ',';
          // });
          str = str.substring(0, str.lastIndexOf(','));
          window.location.href = `${this.baseUrl}${API.EXPORT_MATERIAL}?${str}&access_token=${this.token.access_token}`;
        } else {
          const params = XEUtils.serialize(this.searchForm);
          window.location.href = `${this.baseUrl}${API.EXPORT_MATERIAL}?${params}&access_token=${this.token.access_token}`;
        }
      },
      handleForbid() {
        if (this.multipleSelection.length > 0) {
          let productCode = [];
          for (let item of this.multipleSelection) {
            if (item.productStatus !== '001') {
              productCode.push(item.productCode);
            } else {
              this.$message({
                showClose: true,
                message: this.$t('rawData.message.delete_to_enable'),
                type: 'error',
              });
              return false;
            }
          }
          const params = { delCodes: productCode };
          this.$confirmAction(this.$t('confirm.delete'))
            .then(() => {
              this.$axios.post(API.DELETE_PRODUCT, params).then((res) => {
                if (res.data.code === 0) {
                  this.$message({
                    showClose: true,
                    message: this.$t('rawData.message.deleteSuccess'),
                    type: 'success',
                  });
                  this.multipleSelection = [];
                  this.$refs.siruiTable.clearCheckboxRow();
                  this.resetBtnClick();
                } else {
                  this.$alert(res.data.msg);
                }
              });
            })
            .catch(() => {
              this.$message({
                showClose: true,
                type: 'info',
                message: this.$t('confirm.deleteCancelled'),
              });
            });
        } else {
          this.$message({
            showClose: true,
            message: this.$t('rawData.message.pleaseSelectOne'),
            type: 'error',
          });
        }
      },
      // 设置导入配置
      setImport() {
        this.importUrl = API.IMPORT_MATERIAL;
        let { tenantCode, access_token, companyCode, companyName, departmentCode, departmentName } =
          this.userInfo;
        this.importData = {
          tenantCode,
          access_token,
          companyCode,
          companyName,
          departmentCode,
          departmentName,
          productClass: '0',
        };
      },
      // 批量导入
      handleImport() {
        this.$refs.siruiUpload.openDialog(true);
      },
      dblclickEvent(e) {
        this.$baseRequest.linkRouteUrl(
          '/production/rawDataAdd',
          'rawDataAdd',
          '修改原料主数据明细',
          { id: e.row.id, isEdit: 'Y' }
        );
      },
      changeCompany() {},
      showChild(row) {
        //["2342(234234)", "1(133)", "2(3)"]
        if (row.confimProductNameSpec == null) return;
        let result = row.confimProductNameSpec.split(',');
        let arr = [];
        for (let item of result) {
          arr.push({
            productName: item.split('(')[0],
            productSpec: item.split('(')[1].split(')')[0],
          });
        }
        return arr;
      },
    },
  };
</script>
<style scoped>
  .childDataTable {
    width: 800px !important;
  }
</style>
